import { modelOptions, post, prop } from "@typegoose/typegoose";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";

const SCHEMA_KEY = "DeviceUpdateTiming" as const;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<DeviceUpdateTiming>>(...addSchemaKeyHook(SCHEMA_KEY))
/**
 * @deprecated Don't think this is used anymore and can probably be deleted
 */
export class DeviceUpdateTiming extends SchemaBase<DeviceUpdateTiming> {
    static schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => Number, required: false })
    public activeHoursStart?: number;

    @prop({ type: () => Number, required: false })
    public activeHoursDuration?: number;

    @prop({ type: () => Number, required: true, default: 60 * 1000 * 60 })
    public activeHoursUplinkPeriod: number = 60 * 1000 * 60;

    @prop({ type: () => Number, required: true, default: 60 * 1000 * 60 })
    public inactiveHoursUplinkPeriod: number = 60 * 1000 * 60;

    static getters = {} as const satisfies Record<string, (self: DeviceUpdateTiming) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<DeviceUpdateTiming>) {
        super(properties);
        Object.assign(this, properties);
    }
}
